import { createApp } from 'vue'
import App from './App.vue'
import router from './router.js';
import bootstrap from'bootstrap';
import btcs from 'bootstrap/dist/css/bootstrap.css';
import btmnc from 'bootstrap/dist/css/bootstrap.min.css';
import VueGtag from 'vue-gtag'
import vue3GoogleLogin from 'vue3-google-login';
import './registerServiceWorker'

const app = createApp(App)
app.use(router);
app.use(VueGtag,{config: { id: 'G-1EF80CWDG6' }});
app.use(bootstrap,btmnc,btcs);
app.use(vue3GoogleLogin, {
    clientId: '998158321099-9eo00sm34u3p06as7nas05d9esulop0j.apps.googleusercontent.com'
  })


app.mount('#app');
